module.exports = __webpack_public_path__ + "login-16-9-min.b6a496dad3626f9e5918.jpg";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/images/login-16-9-min.jpg
// module id = ../../../../../src/assets/images/login-16-9-min.jpg
// module chunks = styles